import { MissionToLecStaff } from '../../lib/types/models/mission-to-lec-staff/mission-to-lec-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AddLecStaffsToMissionInput = {
  id: number
  userIds: number[]
}

export function addLecStaffsToMission(input: AddLecStaffsToMissionInput) {
  const { id, userIds } = input
  return restApiClient
    .url(constructApiUrl(API.missions.addLecStaffsToMission.url, { id }))
    .post<MissionToLecStaff>({ userIds })
}
